import { SET_BLOCKS, SET_BLOCKS_LOADING, SET_SEGMENTS, SET_SEGMENTS_LOADING } from '../constants';

interface Block {
  id: number;
  survey_id: string;
  title: string;
  survey_order: number;
  is_free: boolean;
  account_id: string | null;
}

interface Segment {
  id: number;
  block_id: number;
  page_id: string;
  question_id: string;
  content: string;
  project_id: number;
}

interface BlocksState {
  list: Block[];
  loading: boolean;
  // segments keyed by projectId
  segments: Record<string, Segment[]>;
  segmentsLoading: boolean;
}

const initialState: BlocksState = {
  list: [],
  loading: false,
  segments: {},
  segmentsLoading: false,
};

export default function blocksReducer(state = initialState, action: any): BlocksState {
  switch (action.type) {
    case SET_BLOCKS:
      return { ...state, list: action.payload };
    case SET_BLOCKS_LOADING:
      return { ...state, loading: action.payload };
    case SET_SEGMENTS:
      return {
        ...state,
        segments: {
          ...state.segments,
          [action.payload.projectId]: action.payload.segments,
        },
      };
    case SET_SEGMENTS_LOADING:
      return { ...state, segmentsLoading: action.payload };
    default:
      return state;
  }
}
